const normalize = value => typeof value === 'string' ? value.trim().toLowerCase() : '';

// A shared contact reference is one record, even when several customers list it.
export const buildContactDuplicateRows = (customers = []) => {
    const records = new Map();
    for (const customer of customers) {
        for (const contact of customer.contacts || []) {
            if (!contact?._id) continue;
            const id = String(contact._id);
            if (!records.has(id)) records.set(id, { ...contact, customers: [] });
            const row = records.get(id);
            if (!row.customers.some(item => String(item._id) === String(customer._id))) {
                row.customers.push({ _id: customer._id, organizationName: customer.organizationName });
            }
        }
    }
    const groups = new Map();
    const addGroup = (key, id) => {
        if (!groups.has(key)) groups.set(key, new Set());
        groups.get(key).add(id);
    };
    for (const [id, row] of records) {
        const email = normalize(row.primaryEmail);
        const first = normalize(row.firstName);
        const last = normalize(row.lastName);
        row.duplicateKeys = [];
        if (email) row.duplicateKeys.push(JSON.stringify(['email', email]));
        if (first && last) {
            for (const customer of row.customers) {
                if (customer._id) row.duplicateKeys.push(JSON.stringify(['name', String(customer._id), first, last]));
            }
        }
        row.duplicateKeys.forEach(key => addGroup(key, id));
    }
    return [...records.entries()].map(([id, row]) => {
        const matches = new Map();
        for (const key of row.duplicateKeys) {
            const reason = JSON.parse(key)[0] === 'email' ? 'Same email' : 'Same name and customer';
            for (const matchId of groups.get(key)) {
                if (matchId === id) continue;
                if (!matches.has(matchId)) matches.set(matchId, new Set());
                matches.get(matchId).add(reason);
            }
        }
        const { duplicateKeys, ...contact } = row;
        return {
            ...contact,
            organizationName: row.customers.map(customer => customer.organizationName).filter(Boolean).join(', '),
            duplicateCount: matches.size,
            duplicateMatches: [...matches].map(([matchId, reasons]) => ({ id: matchId, reasons: [...reasons] })),
        };
    });
};
